<template>
  <div class="reportes-actividades">
    <div class="content-header">
      <h1 class="content-header-title">Reportes de Actividades</h1>
      <p class="content-header-subtitle">Genera reportes detallados de actividades</p>
    </div>
    <b-card>
      <div class="text-center py-5">
        <feather-icon icon="BarChartIcon" size="48" class="text-muted mb-3" />
        <h5 class="text-muted">Reportes de Actividades</h5>
        <p class="text-muted">Funcionalidad de reportes en desarrollo</p>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'ReportesActividades',
}
</script>

<style lang="scss" scoped>
.reportes-actividades {
  padding: 1.5rem;
}

.content-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.content-header-title {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.content-header-subtitle {
  color: #6c757d;
  margin-bottom: 0;
}
</style>
